import React, { Component } from 'react';
import { FontAwesome } from '../';
import logo from 'img/logos/th.svg';
import './Spinner.scss';
import './LoadingScreen.scss';

export const InlineSync = ({ loading, icon }) => {
  return <FontAwesome icon={!loading && icon ? icon : 'sync-alt'} spin={loading} />;
}

export class Spinner extends Component {
  static defaultProps = { size: 10 }

  render() {
    return <div className='spinner-1' style={{ fontSize: `${this.props.size}px` }}></div>;
  }
}

export class LoadingScreen extends Component {
  static defaultProps = { size: 10 }

  render() {
    return (
      <div id='LoadingScreen'>
        {!this.props.hideLogo && <img src={logo} id='logo' alt='logo' />}
        <Spinner />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/loading/index.js